import React, {useState} from 'react';
import {OperationStateTypesEnum} from 'presentation/constants';
import {usePersonalData} from 'presentation/hooks';
import {useElectronicBillSubscription} from 'presentation/pages/private/hooks/useElectronicBillSubscription';
import {ElectronicBillHomeDrawer} from '../ElectronicBillHomeDrawer';
import {SubscriptionDialogs} from 'presentation/components/SubscriptionDialogs';

export function ElectronicBillSection() {
	const {currentEmail} = usePersonalData();

	const [subscriptionOperationState, setOperationSubscriptionState] =
		useState<OperationStateTypesEnum>(OperationStateTypesEnum.NONE);

	const isSubmittingSubscription =
		subscriptionOperationState === OperationStateTypesEnum.SUBMITTING;

	const {
		handleSubscriptionResponse,
		handleCloseSubscriptionSucessModal,
		handleToggleShowInfoModal,
		handleToggleSubscriptionModal,
		protocol,
	} = useElectronicBillSubscription();

	return (
		<>
			<ElectronicBillHomeDrawer />
			<SubscriptionDialogs
				isSubmitting={isSubmittingSubscription}
				onSubscriptionResponse={handleSubscriptionResponse}
				onCloseSubscriptionModal={() => handleToggleSubscriptionModal(false)}
				onCloseSubscriptionSucessModal={handleCloseSubscriptionSucessModal}
				onShowSubscriptionModal={() => handleToggleSubscriptionModal(true)}
				onCloseInfoModal={() => handleToggleShowInfoModal(false)}
				onShowInfoModal={() => handleToggleShowInfoModal(true)}
				currentEmail={currentEmail}
				protocol={protocol}
				setOperationState={setOperationSubscriptionState}
			/>
		</>
	);
}
